// extracted by mini-css-extract-plugin
export var sliderRange = "_rv-2";
export var sliderRoot = "_rv-0";
export var sliderThumb = "_rv-3";
export var sliderTrack = "_rv-1";